// Carries a copy version ?view= code (see README) from the page a visitor
// lands on to the homepage and product links they click for the rest of
// their visit. Other links are left alone.
(function () {
  // Must match the lookup in sections/main-product.liquid and sections/featured-product.liquid
  const CODES = ['k7x2m9', 'p4qz8t', 'w2nb6r', 'h9vc3j'];
  const STORAGE_KEY = 'copyVersionView';

  const fromUrl = new URLSearchParams(window.location.search).get('view');
  let code = CODES.includes(fromUrl) ? fromUrl : null;

  try {
    if (code) {
      sessionStorage.setItem(STORAGE_KEY, code);
    } else {
      code = sessionStorage.getItem(STORAGE_KEY);
    }
  } catch (error) {
    // Storage can be unavailable (e.g. some private browsing modes); fall back to the URL only
  }

  if (!CODES.includes(code)) return;

  const rootPath = window.Shopify?.routes?.root || '/';

  function isVersionedPath(pathname) {
    return pathname === rootPath || /\/products\/[^/.]+\/?$/.test(pathname);
  }

  function addCode(link) {
    const href = link.getAttribute('href');
    if (!href || href.startsWith('#')) return;

    let url;
    try {
      url = new URL(href, window.location.href);
    } catch (error) {
      return;
    }

    if (url.origin !== window.location.origin || url.searchParams.has('view') || !isVersionedPath(url.pathname)) return;

    url.searchParams.set('view', code);
    link.setAttribute('href', url.pathname + url.search + url.hash);
  }

  // Links are updated as they're used, so links added later (search, drawers, recommendations) are covered too
  function handleEvent(event) {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[href]');
    if (link) addCode(link);
  }

  document.addEventListener('pointerdown', handleEvent, true);
  document.addEventListener('focusin', handleEvent, true);
  document.addEventListener('click', handleEvent, true);
})();
